import { Flex, Text } from "@mantine/core";
import type { JSX } from "react";
import { PurpleIndicator } from "./icons";
import classes from "./MicroLearning.module.css";

interface ProgressBarProps {
    currentQuestionNumber: number;
    totalNumberOfQuestions: number;
    progressWidth: number;
}

export function ProgressBar({
    currentQuestionNumber,
    totalNumberOfQuestions,
    progressWidth,
}: ProgressBarProps): JSX.Element {
    const progress =
        ((currentQuestionNumber === 0 ? 1 : currentQuestionNumber) / totalNumberOfQuestions) * progressWidth;
    return (
        <Flex className={classes.progressBackground} w={progressWidth}>
            <Flex className={classes.endIndicator}>
                <PurpleIndicator />
                <Flex w={0} className={classes.indicatorText}>
                    <Text fz="xs" fw={700} c="primary.3">
                        {totalNumberOfQuestions}
                    </Text>
                </Flex>
            </Flex>
            <Flex className={classes.progress} w={progress}>
                <Flex className={classes.indicator}>
                    <PurpleIndicator stroke="#7724BE" fill="#B67BE8" />
                    <Flex w={0} className={classes.indicatorText}>
                        <Text fz="xs" fw={700} c="primary.8">
                            {currentQuestionNumber}
                        </Text>
                    </Flex>
                </Flex>
            </Flex>
        </Flex>
    );
}
